import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
  view: {
    height: '100%',
    overflowY: 'hidden',
    overflowX: 'hidden'
  },
  grayView: {
    position: 'absolute',
    left: '0px',
    right: '0px',
    top: '0px',
    bottom: '0px',
    padding: '0px 33px',
    '@media (minWidth: 800px)': {
      padding: '0px 70px !important'
    },
    background: `linear-gradient(0deg, #6B6B6B, #6B6B6B)`,
    zIndex: 9
  },
  View: {
    position: 'absolute',
    left: '0px',
    right: '0px',
    top: '0px',
    bottom: '0px',
    padding: '0px 33px',
    '@media (minWidth: 800px)': {
      padding: '0px 257px !important'
    },
    background: `linear-gradient(0deg, #6B6B6B, #6B6B6B)`,
    zIndex: 9
  },
  grayText: {
    ...theme.typography.heading4,
    alignSelf: 'center',
    color: '#fff',
    whiteSpace: 'pre-line'
  },
  bigFont: {
    ...theme.typography.heading3,
    alignSelf: 'center',
    color: '#FFF',
    marginBottom: '32px',
    whiteSpace: 'pre-line'
  },
  text: {
    ...theme.typography.heading5,
    fontWeight: '500',
    alignSelf: 'center',
    color: '#FFF',
    marginBottom: '32px',
    whiteSpace: 'pre-line'
  },
  absoluteGrayView: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }
}));
